var toSentence = require('./toSentence');

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/toSentenceSerial.js
// module id = N1cn
// module chunks = 0